import { SURVEY_TEXT_LIMITS } from './surveys';

export const formsConstants = {
    FORMS_REQUEST: 'FORMS_REQUEST',
    FORMS_SUCCESS: 'FORMS_SUCCESS',
    FORMS_ERROR: 'FORMS_ERROR',
};

export const FORM_INTERNAL_NAME_MAX_LENGTH = 256;

export const FORM_TEXT_FIELDS = [
    { name: 'title', label: 'common.title', maxLength: SURVEY_TEXT_LIMITS.title },
    {
        name: 'description',
        label: 'common.description',
        maxLength: SURVEY_TEXT_LIMITS.message,
        multiline: true,
        optional: true,
    },
    {
        name: 'confirmationMessage',
        label: 'FormsPage.confirmationMessage',
        maxLength: SURVEY_TEXT_LIMITS.message,
        multiline: true,
    },
];

export const PREVIEW_FORM_MESSAGE = 'pl-preview-form';
